import { Check } from "lucide-react";
import { resolveImageUrl } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";

export default function DuplicateGroup({ group, selected, onToggle, showOwner }) {
  const { t } = useLang();
  return (
    <section className="border-t border-zinc-800 py-8" data-testid={`dup-group-${group.hash.slice(0, 12)}`}>
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
        {t("dup_group", group.photos.length)}
      </div>
      <div className="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {group.photos.map((p) => {
          const del = selected.has(p.id);
          return (
            <button
              type="button"
              key={p.id}
              onClick={() => onToggle(p.id)}
              aria-pressed={del}
              className={`text-left border transition-colors ${del ? "border-sienna bg-sienna/5" : "border-zinc-800 hover:border-zinc-600"}`}
              data-testid={`dup-photo-${p.id}`}
            >
              <img src={resolveImageUrl(p.thumb_url)} alt={p.title} loading="lazy" className={`w-full aspect-[4/3] object-cover bg-zinc-900 ${del ? "opacity-50" : ""}`} />
              <div className="p-3 space-y-1">
                <div className="text-sm text-zinc-100 truncate">{p.title || "Untitled"}</div>
                {showOwner && <div className="text-xs text-zinc-400 truncate">{p.user_name}</div>}
                <div className="text-[11px] text-zinc-500 font-mono">
                  {t("dup_uploaded")} {new Date(p.created_at).toLocaleDateString()} · {p.views} {t("stats_views")}
                </div>
                <div className={`inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.25em] ${del ? "text-sienna-400" : "text-zinc-300"}`} data-testid={`dup-photo-state-${p.id}`}>
                  {del ? t("dup_delete_mark") : <><Check size={12} /> {t("dup_keep")}</>}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
